// Shared entry loaded by _Layout on every page: fonts, Bootstrap themed to the design tokens,
// spec component styles and the app shell. See docs/design/README.md.
import '@fontsource/figtree/400.css';
import '@fontsource/figtree/500.css';
import '@fontsource/figtree/600.css';
import '@fontsource/figtree/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '../styles/tokens.css';
import '../styles/bootstrap-theme.css';
import '../styles/components.css';
import '../styles/shell.css';
import '../styles/auth.css';
import '../styles/admin.css';
import '../styles/logs.css';
import '../styles/overview.css';
import '../styles/site.css';
import '../components/hl-global-search';
import { bindThemePicker } from '../lib/theme';

bindThemePicker();
